import { Fragment } from 'react';
import { useExperiment } from '../../common/ExperimentContext/useExperiment';
import { useMobile } from '../../common/services/screenSize/ScreenSizeService';
import { RibbonLink, RibbonText, StyledBar } from './AlertBar.styles';
import { AlertBoxExperiment } from './AlertBoxExperiment';

export const AlertBar = () => {
  const experimentData = useExperiment(AlertBoxExperiment);
  const contents = experimentData.loading ? undefined : experimentData.data;
  const isMobile = useMobile();

  const variant = isMobile ? contents?.mobile : contents?.desktop;

  if (!variant) return null;

  return (
    <StyledBar>
      {variant.map((line, index) => (
        <RibbonText key={index}>
          {line.map((segment, segmentIndex) => (
            <Fragment key={segmentIndex}>
              {typeof segment === 'string' && segment}

              {typeof segment === 'object' && (
                <>
                  {' '}
                  <RibbonLink to={segment.href ?? '#'} target={segment.target}>
                    {segment.text}
                  </RibbonLink>{' '}
                </>
              )}
            </Fragment>
          ))}
        </RibbonText>
      ))}
    </StyledBar>
  );
};
